{
  "/ambassadors": {
    "title": "YachtApp Ambassador Program | Earn by Referring Boaters",
    "description": "Join the YachtApp ambassador program. Introduce boat owners, captains, and marine businesses to vessel management software and earn eligible referral commissions.",
    "prerender": true
  },
  "/how-it-works": {
    "title": "How the Ambassador Program Works | YachtApp",
    "description": "Learn how to apply, get approved, share your YachtApp referral link, and track eligible subscriptions and commissions through the ambassador portal.",
    "prerender": true
  },
  "/commission-plans": {
    "title": "Ambassador Commission Plans | YachtApp",
    "description": "Explore example YachtApp ambassador commission plans for new partners, marine professionals, and high-volume channels. Final terms are confirmed during approval.",
    "prerender": true
  },
  "/who-should-join": {
    "title": "Who Can Join the Ambassador Program? | YachtApp",
    "description": "Discover the YachtApp ambassador program for marine professionals, sailing clubs, schools, creators, and individuals with a relevant boating audience.",
    "prerender": true
  },
  "/marketing-resources": {
    "title": "Ambassador Marketing Resources | YachtApp",
    "description": "Discover marketing materials available to approved YachtApp ambassadors, including QR codes, flyers, social graphics, product screenshots, and presentations.",
    "prerender": true
  },
  "/faq": {
    "title": "Ambassador Program FAQ | YachtApp",
    "description": "Find answers about YachtApp ambassador eligibility, commissions, payouts, refunds, referral attribution, and promotion guidelines before applying.",
    "prerender": true
  },
  "/signup": {
    "title": "Apply to Become a YachtApp Ambassador",
    "description": "Create your YachtApp ambassador account to start your application and prepare for review of your profile and preferred referral link.",
    "prerender": false
  },
  "/reset-password": {
    "title": "Reset Your Password | YachtApp Ambassadors",
    "description": "Request a secure password reset link for your YachtApp account and return to the ambassador portal to sign in.",
    "prerender": false
  },
  "/not-found": {
    "title": "Page Not Found | YachtApp Ambassadors",
    "description": "This page is unavailable. Return to the YachtApp ambassador program, read the program FAQ, or sign in to your account.",
    "prerender": false
  },
  "/login": {
    "title": "Ambassador Login | YachtApp",
    "description": "Sign in to your YachtApp ambassador account to access your profile, referral tools, reporting, and resources.",
    "prerender": false
  }
}
